/* eslint-disable no-console */
import React, { useCallback, useEffect, useState } from 'react';

// eslint-disable-next-line import/no-extraneous-dependencies
import classnames from 'classnames';
import {
  Button,
  Col,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  ModalFooter,
} from 'reactstrap';
import { toast } from 'react-toastify';
import MainCGM from './subComponents/MainCGM';
import './subComponents/styles.css';
import ManagerCGM from './subComponents/ManagerCGM';
import AddComponent from './subComponents/AddComponent';
// eslint-disable-next-line import/order
import { useDispatch, useSelector } from 'react-redux';
import SupportCGM from './subComponents/SupportCGM';
import CompaniesCGM from './subComponents/CompaniesCGM';
import AdminsCGM from './subComponents/AdminsCGM';
import { getCompanyNumbers } from '../../actions/Numbers';
import { getCompanyGroupManager, getSupportEngineers } from '../../actions/Companies';
import './CompanyGroupManager.css';
import TAB_OPTION from './helper';

const groupItems = [
  // { label: '', value: '' },
  { label: 'CSG', value: 'CSG' },
  { label: 'Granite', value: 'Granite' },
  { label: 'Bullseye', value: 'Bullseye' },
];
const errors = {
  admins: 'This admin is already added in list!',
  support: 'This user is already added in support Engineer list!',
  manager: 'This user is already added in Group Managers list!',
  companies: 'This company is already in this management group.',
};
const CompanyGroupManagement = ({ onCancel, onConfirm }) => {
  const dispatch = useDispatch();
  const token = localStorage.getItem('jwtToken') || null;

  const groupAdmins = useSelector(state => state.UIState.numbers.addNumberFieldChange);
  const companyGroupData = useSelector(state => state.UIState.companies.addCompanyGroupChange);
  const editCompanyGroup = useSelector(state => state.UIState.companies.editCompanyGroupData);

  const companies =
    useSelector(state => state.AppState.companies)?.docs?.map(company => ({
      ...company,
      email: company.name,
    })) || [];

  const [selected, setSelected] = useState('main');
  const [selectedList, setSelectedList] = useState([]);

  const [adminList, setAdminList] = useState([]);
  const [supportList, setSupportList] = useState([]);
  const [managerList, setManagerList] = useState([]);

  const [adminSelectedList, setAdminSelectedList] = useState([]);
  const [supportSelectedList, setSupportSelectedList] = useState([]);
  const [managerSelectedList, setManagerSelectedList] = useState([]);
  const [companySelectedList, setCompanySelectedList] = useState([]);
  const [companyBoxesIDs, setBoxesIDs] = useState([]);

  const [loading, setLoading] = useState(false);

  const [selectedValue, setSelectedValue] = useState('');
  const [noDropdownValue, setNoDropdownValue] = useState([]);
  const [state, setState] = useState({
    hostTag: {},
    name: '',
    company: {},
  });

  const getGroupAdmins_ = useCallback(async () => {
    setLoading(true);

    const suggestion = { _id: editCompanyGroup.company._id, name: editCompanyGroup.company.name };

    const admins = await dispatch(
      getCompanyNumbers(token, suggestion._id, false, 'companyGroupAdmin', true),
    );

    setAdminList(admins);
    setLoading(false);

    return admins;
  }, [editCompanyGroup]);

  const getGroupManagers_ = useCallback(async () => {
    setLoading(true);

    const suggestion = { _id: editCompanyGroup.company._id, name: editCompanyGroup.company.name };

    const companyGroupManagers = await dispatch(
      getCompanyGroupManager(token, suggestion._id, false, 'companyGroupManager', true),
    );

    setManagerList(companyGroupManagers);
    setLoading(false);

    return companyGroupManagers;
  }, [editCompanyGroup]);

  const getSupportEngineers_ = useCallback(async () => {
    setLoading(true);

    const suggestion = { _id: editCompanyGroup.company._id, name: editCompanyGroup.company.name };

    const supportEngineers = await dispatch(
      getSupportEngineers(token, suggestion._id, false, 'supportEngineer', true),
    );

    setSupportList(supportEngineers);
    setLoading(false);

    return supportEngineers;
  }, [editCompanyGroup]);

  const getInitialSelected = useCallback(
    async selected_ => {
      let adminDraft = [...(adminList?.length ? [adminList] : [])];
      let managerDraft = [...(managerList?.length ? [managerList] : [])];
      let supportDraft = [...(supportList?.length ? [supportList] : [])];

      if (!adminDraft?.length && selected_ === TAB_OPTION.ADMINS) {
        const draft = await getGroupAdmins_();
        if (draft?.emails?.length) {
          adminDraft = [...draft.emails];
        }
      }

      if (!managerDraft?.length && selected_ === TAB_OPTION.MANAGER) {
        const draft = await getGroupManagers_();
        if (draft?.emails?.length) {
          managerDraft = [...draft?.emails];
        }
      }

      if (!supportDraft?.length && selected_ === TAB_OPTION.SUPPORT) {
        const draft = await getSupportEngineers_();
        if (draft?.emails?.length) {
          supportDraft = [...draft?.emails];
        }
      }

      switch (selected_) {
        case TAB_OPTION.ADMINS:
          return adminDraft;
        case TAB_OPTION.MANAGER:
          return managerDraft;
        case TAB_OPTION.SUPPORT:
          return supportDraft;
        case TAB_OPTION.COMPANIES:
          return companies;
        default:
          return [];
      }
    },
    [selected, editCompanyGroup, adminList, managerList, supportList, editCompanyGroup],
  );

  const onAddedCompanyChange = async ({ name, value, suggestion }) => {
    const groupAdminsList = await dispatch(
      getCompanyNumbers(token, suggestion._id, false, 'companyGroupAdmin', true),
    );
    const groupManagersList = await dispatch(
      getCompanyGroupManager(token, suggestion._id, false, 'companyGroupManager', true),
    );
    const supportEngineersList = await dispatch(
      getSupportEngineers(token, suggestion._id, false, 'supportEngineer', true),
    );
    setAdminList(groupAdminsList);
    setManagerList(groupManagersList);
    setSupportList(supportEngineersList);
  };
  useEffect(() => {
    if (editCompanyGroup) {
      setAdminSelectedList(editCompanyGroup.groupSuperAdmins);
      setManagerSelectedList(editCompanyGroup.groupManagers);
      setSupportSelectedList(editCompanyGroup.supportEngineers);
      setCompanySelectedList(editCompanyGroup.managedCompanies);
      setBoxesIDs(editCompanyGroup.boxes);
      const defaultState = {
        hostTag: editCompanyGroup.hostTag ? { value: editCompanyGroup.hostTag } : {},
        name: editCompanyGroup.name ?? '',
        company: editCompanyGroup.company ? { value: editCompanyGroup.company._id } : {},
      };
      setState(defaultState);

      // Uncomment if all calls are required in one go (Unstable Implementation)
      /* onAddedCompanyChange({
        name: editCompanyGroup.company.name,
        value: editCompanyGroup.name,
        suggestion: { _id: editCompanyGroup.company._id, name: editCompanyGroup.company.name },
      }); */
    }
  }, [editCompanyGroup]);

  const handleEditCompanyGroupCallMethod = useCallback(async e => {
    const val_ = await getInitialSelected(e);
    const shallowClone = val_?.length ? [...val_] : [];
    setSelectedList(shallowClone);
  }, []);

  const onInputChange = e => {
    if (e) setSelectedValue(e.suggestion);
  };

  const onTabChange = useCallback(async e => {
    setSelected(e);
    setSelectedValue('');
    await handleEditCompanyGroupCallMethod(e);
  }, []);

  // add item to selectedList array and set selectedValue to empty string on onAddButtonClick
  const onAddButtonClick = () => {
    console.log({
      selectedValue,
      selectedList,
      adminList,
      selected,
    });
    var selectedItem;
    switch (selected) {
      case 'admins':
        console.log({ adminSelectedList });
        selectedItem = adminSelectedList.find(item => item.email === selectedValue.email);
        break;
      case 'manager':
        console.log({ managerSelectedList });
        selectedItem = managerSelectedList.find(item => item.email === selectedValue.email);
        break;
      case 'support':
        console.log({ supportSelectedList });
        selectedItem = supportSelectedList.find(item => item.email === selectedValue.email);
        break;
      default:
        console.log({ companySelectedList });
        selectedItem = companySelectedList.find(item => item._id === selectedValue._id);
        break;
    }
    console.log({ selectedItem });
    // add selectedItem in the selectedList.emails array
    if (!selectedItem) {
      console.log('selectedItem', selectedValue);
      // check if selectedItem is already in the adminSelectedList array
      switch (selected) {
        case 'admins':
          setAdminSelectedList([...adminSelectedList, selectedValue]);
          break;
        case 'manager':
          setManagerSelectedList([...managerSelectedList, selectedValue]);
          break;
        case 'support':
          setSupportSelectedList([...supportSelectedList, selectedValue]);
          break;
        default:
          setCompanySelectedList([...companySelectedList, selectedValue]);
          break;
      }

      setSelectedValue('');
    } else {
      toast.error(errors[selected]);
    }
  };

  const onDelete = (data, index) => {
    var newList;
    switch (selected) {
      case 'admins':
        newList = adminSelectedList.filter(item => item.email !== data.email);
        setAdminSelectedList(newList);
        break;
      case 'manager':
        newList = managerSelectedList.filter(item => item.email !== data.email);
        console.log({ data, managerSelectedList, newList });
        setManagerSelectedList(newList);
        break;
      case 'support':
        newList = supportSelectedList.filter(item => item.email !== data.email);
        setSupportSelectedList(newList);
        break;
      default:
        newList = companySelectedList.filter(item => item._id !== data._id);
        setCompanySelectedList(newList);
        break;
    }
  };
  const onStateChange = (value, key) => {
    if (key == 'company') {
      onAddedCompanyChange({
        name: value.label,
        value: value.value,
        suggestion: { _id: value.value, name: value.label },
      });
    }
    setState(s => {
      return {
        ...s,
        [key]: value,
      };
    });
  };
  const submit = () => {
    onConfirm({
      ...state,
      company: state.company?.value || '',
      hostTag: state.hostTag?.value || '',
      groupSuperAdmins: adminSelectedList,
      managedCompanies: companySelectedList,
      supportEngineers: supportSelectedList,
      groupManagers: managerSelectedList,
    });
  };
  return (
    <>
      <div>
        <Row>
          <Col sm={6}>
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: selected === 'main' })}
                  onClick={() => onTabChange('main')}
                >
                  Main
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: selected === 'admins' })}
                  onClick={() => onTabChange('admins')}
                >
                  Group Admins
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={classnames({ active: selected === 'support' })}
                  onClick={() => onTabChange('support')}
                >
                  Support Engineer
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={classnames({ active: selected === 'manager' })}
                  onClick={() => onTabChange('manager')}
                >
                  Group Managers
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: selected === 'companies' })}
                  onClick={() => onTabChange('companies')}
                >
                  Managed Companies
                </NavLink>
              </NavItem>
            </Nav>
          </Col>

          <Col sm={6}>
            {['admins', 'support', 'manager', 'companies'].includes(selected) && (
              <AddComponent
                onClick={onAddButtonClick}
                searchTerm={'email'}
                dropdownList={selectedList || []}
                isDisabled={false}
                placeholder={`Search ${selected}...`}
                onChange={onInputChange}
                value={selectedValue || {}}
                name={selected}
                loading={loading}
                onKeyDown={setNoDropdownValue}
              />
            )}
            {/* {selected === 'managed' && (
            <Col className="managed__header__row">
              <Input placeholder="Group Name" required type="text" name="name" />
              <Button color="primary" className="w-50" onClick={() => null}>
                Add Group
              </Button>
            </Col>
          )} */}
          </Col>
        </Row>
        <Row>
          <Col className={'scroll-bar-highted'} sm={12}>
            <TabContent activeTab={selected}>
              <TabPane tabId="main">
                {selected === 'main' && (
                  <MainCGM groupItems={groupItems} state={state} onStateChange={onStateChange} />
                )}
              </TabPane>

              <TabPane tabId="admins">
                {selected === 'admins' && (
                  <AdminsCGM
                    seletedAdmins={adminSelectedList}
                    loading={loading}
                    onDelete={onDelete}
                    selectedValue={selectedValue}
                    noDropdownValue={noDropdownValue}
                  />
                )}
              </TabPane>

              <TabPane tabId="support">
                {selected === 'support' && (
                  <SupportCGM
                    seletedSupport={supportSelectedList}
                    loading={loading}
                    onDelete={onDelete}
                  />
                )}
              </TabPane>

              <TabPane tabId="manager">
                {selected === 'manager' && (
                  <ManagerCGM
                    seletedManagers={managerSelectedList}
                    loading={loading}
                    onDelete={onDelete}
                  />
                )}
              </TabPane>

              <TabPane tabId="companies">
                {selected === 'companies' && (
                  <CompaniesCGM
                    seletedCompanies={companySelectedList}
                    loading={loading}
                    onDelete={onDelete}
                    boxesData={companyBoxesIDs}
                  />
                )}
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </div>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel}>
          {'Close'}
        </Button>

        <Button color="primary" onClick={submit}>
          {'Submit'}
        </Button>
      </ModalFooter>
    </>
  );
};

export default CompanyGroupManagement;
